
import { Component } from '@angular/core';
import { MercadoPagoComponent } from "./components/mercado-pago/mercado-pago.component";
import { CashPaymentComponent } from "./cash-payment/cash-payment.component";

@Component({
  selector: 'shared-metodos-pagos',
  imports: [MercadoPagoComponent, CashPaymentComponent],
  templateUrl: './metodos-pagos.component.html',
  styleUrl: './metodos-pagos.component.css'
})
export class MetodosPagosComponent {

}
